export default __webpack_public_path__ + "static/media/7.81c7d8f9.jpeg";